<template>
  <div class="service-config-container">
    <div class="service-header">
      <p>服务器配置</p>
    </div>
    <div class="common-tabs-box">
      <el-tabs
        v-model="activeTab"
        tab-position="left"
        class="tabs-box">
        <el-tab-pane
          label="commonUrl"
          name="commonUrl">
          <el-form
            ref="commonUrlForm"
            class="server-form-box public-form-primary"
            :model="commonUrlForm"
            label-width="110px"
            :rules="rules">
            <el-form-item
              label="commonUrl"
              prop="commonUrl">
              <div class="justify-flex">
                <el-input
                  class="input-primary"
                  v-model="commonUrlForm.commonUrl"
                  placeholder="commonUrl地址，如：http://192.168.31.6:8088/default.aspx"></el-input>
                <el-button
                  class="primary-btn"
                  style="margin-left: 20px"
                  type="primary"
                  @click="submitGlobalConfig"
                  >提交配置</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          label="配置服务器"
          name="server">
          <el-form
            ref="serverForm"
            class="server-form-box public-form-primary"
            :model="serverForm"
            label-width="150px"
            :rules="rules">
            <el-form-item label="是否启用MinIO">
              <el-switch
                class="switch-primary"
                v-model="serverForm.isMinio"></el-switch>
            </el-form-item>
            <el-form-item label="是否启用转换服务">
              <el-switch
                class="switch-primary"
                v-model="serverForm.isAllowConvert"></el-switch>
            </el-form-item>
            <el-form-item
              class="serve-config-form"
              label="转换数量"
              prop="conversionNum">
              <el-input
                class="input-primary"
                v-model="serverForm.conversionNum"
                placeholder="请输入转换数量，例如:1"></el-input>
            </el-form-item>
            <el-form-item
              class="serve-config-form"
              label="资源发布地址"
              prop="resourcesAddress">
              <el-input
                class="input-primary"
                v-model="serverForm.resourcesAddress"
                placeholder="请输入资源发布地址，例如:https://192.168.1.1:8000"></el-input>
            </el-form-item>

            <el-form-item class="last-item">
              <el-button
                class="primary-btn"
                type="primary"
                @click="next"
                >下一步</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          label="转换平台配置"
          name="zoneManageServers"
          class="transform-config">
          <div class="top-btn">
            <el-button
              type="primary"
              class="primary-btn"
              @click="openZoneManageServersDialog">
              添加转换平台配置</el-button
            >
            <el-button
              class="normal-btn"
              type="primary"
              @click="submitGlobalConfig"
              >提交配置</el-button
            >
          </div>
          <div class="common-table-box">
            <el-table
              v-if="zoneManageServers?.length"
              class="publish-table"
              highlight-selection-row
              :data="zoneManageServers">
              <el-table-column
                prop="zoneId"
                label="转换节点编码"
                width="180">
              </el-table-column>
              <el-table-column
                prop="rootName"
                label="资源发布名称"
                width="180">
              </el-table-column>
              <el-table-column
                prop="rootDir"
                label="资源发布目录">
              </el-table-column>
              <el-table-column
                prop="remoteHostUrl"
                label="远程Url地址">
              </el-table-column>
              <el-table-column
                label="操作"
                width="80">
                <template slot-scope="scope">
                  <div class="operation-cell">
                    <el-button
                      type="text"
                      size="medium"
                      @click="deleteRow(scope.$index, zoneManageServers)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <bj-empty
              v-else
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description"
                ><span class="empty-text">抱歉,没有找到相关内容</span></template
              >
            </bj-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="添加分布式"
          name="addDistributed"
          class="transform-config">
          <div class="top-btn">
            <el-button
              class="primary-btn"
              type="primary"
              @click="openServersConfigDialog"
              >添加分布式配置</el-button
            >
            <el-button
              class="normal-btn"
              type="primary"
              @click="submitGlobalConfig"
              >提交配置</el-button
            >
          </div>
          <div class="common-table-box">
            <el-table
              v-if="servers?.length"
              class="publish-table"
              :data="servers">
              <el-table-column
                prop="ip"
                label="ip地址"
                width="180">
              </el-table-column>
              <el-table-column
                prop="exePath"
                label="转换程序">
              </el-table-column>
              <el-table-column
                prop="cachePath"
                label="缓存文件路径">
              </el-table-column>
              <el-table-column
                label="操作"
                width="80">
                <template slot-scope="scope">
                  <div class="operation-cell">
                    <el-button
                      type="text"
                      @click="deleteRow(scope.$index, servers)"
                      >删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <bj-empty
              v-else
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description"
                ><span class="empty-text">抱歉,没有找到相关内容</span></template
              >
            </bj-empty>
          </div>
        </el-tab-pane>
      </el-tabs>

      <drag-dialog
        title="转换平台配置"
        :width="600"
        :visible.sync="zoneManageServersConfigVisible"
        :footerBtn="['cancel', 'submit']"
        :defaultTop="150"
        :defaultLeft="620"
        :submit="addZoneManageServersConfig"
        :cancel="closeZoneManageServersDialog">
        <el-form
          :model="zoneManageServersForm"
          label-width="110px"
          ref="zoneManageServersForm"
          class="dialog-form public-form-primary"
          :rules="rules">
          <el-form-item
            label="转换节点编码"
            prop="zoneId">
            <el-input
              class="input-primary"
              placeholder="请输入转换节点编码"
              v-model="zoneManageServersForm.zoneId"></el-input>
          </el-form-item>
          <el-form-item
            label="资源发布名称"
            prop="rootName">
            <el-input
              placeholder="请输入资源发布名称"
              class="input-primary"
              v-model="zoneManageServersForm.rootName"></el-input>
          </el-form-item>
          <el-form-item
            label="资源发布目录"
            prop="rootDir">
            <el-input
              placeholder="请输入资源发布目录"
              class="input-primary"
              v-model="zoneManageServersForm.rootDir"></el-input>
          </el-form-item>
          <el-form-item
            label="远程Url地址"
            prop="remoteHostUrl">
            <el-input
              class="input-primary"
              placeholder="请输入远程Url地址"
              v-model="zoneManageServersForm.remoteHostUrl"></el-input>
          </el-form-item>
        </el-form>
      </drag-dialog>

      <drag-dialog
        title="分布式配置"
        :width="600"
        :visible.sync="serversConfigVisible"
        :footerBtn="['cancel', 'submit']"
        :defaultTop="150"
        :defaultLeft="620"
        :submit="addServersConfig"
        :cancel="closeServersConfigDialog">
        <el-form
          :model="serversForm"
          label-width="110px"
          ref="serversForm"
          class="public-form-primary dialog-form"
          :rules="rules">
          <el-form-item
            label="ip地址"
            prop="ip">
            <el-input
              class="input-primary"
              v-model="serversForm.ip"></el-input>
          </el-form-item>
          <el-form-item
            label="转换程序"
            prop="exePath">
            <el-input
              class="input-primary"
              v-model="serversForm.exePath"></el-input>
          </el-form-item>
          <el-form-item
            label="缓存文件地址"
            prop="cachePath">
            <el-input
              class="input-primary"
              v-model="serversForm.cachePath"></el-input>
          </el-form-item>
        </el-form>
      </drag-dialog>
    </div>
  </div>
</template>

<script>
import dragDialog from '@/components/DragDialog.vue'

import {
  getGlobalServerConfig,
  setGlobalServerConfig
} from '@/service/interface'

export default {
  data() {
    return {
      activeTab: 'commonUrl',
      commonUrlForm: { commonUrl: '' },
      serverForm: {
        isMinio: false,
        isAllowConvert: true,
        conversionNum: '',
        resourcesAddress: ''
      },
      zoneManageServers: [],
      zoneManageServersConfigVisible: false,
      zoneManageServersForm: {
        zoneId: '',
        rootName: '',
        rootDir: '',
        remoteHostUrl: ''
      },
      servers: [],
      serversConfigVisible: false,
      serversForm: { ip: '', exePath: '', cachePath: '' },
      rules: {
        commonUrl: [
          {
            required: true,
            message: '请输入资源地址',
            trigger: ['change', 'blur']
          }
        ],
        conversionNum: [
          {
            required: true,
            message: '请输入转换数量',
            trigger: ['change', 'blur']
          }
        ],
        resourcesAddress: [
          {
            required: true,
            message: '请输入资源发布地址',
            trigger: ['change', 'blur']
          }
        ],
        zoneId: [
          {
            required: true,
            message: '请输入转换节点编码',
            trigger: ['change', 'blur']
          }
        ],
        rootName: [
          {
            required: true,
            message: '请输入资源发布名称',
            trigger: ['change', 'blur']
          }
        ],
        rootDir: [
          {
            required: true,
            message: '请输入资源发布目录',
            trigger: ['change', 'blur']
          }
        ],
        remoteHostUrl: [
          {
            required: true,
            message: '请输入远程URL地址',
            trigger: ['change', 'blur']
          }
        ],
        ip: [
          {
            required: true,
            message: '请输入ip地址',
            trigger: ['change', 'blur']
          }
        ],
        exePath: [
          {
            required: true,
            message: '请输入转换程序',
            trigger: ['change', 'blur']
          }
        ],
        cachePath: [
          {
            required: true,
            message: '请输入缓存文件地址',
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },
  components: { dragDialog },
  created() {
    this.initGlobalConfigInfo()
  },
  methods: {
    initGlobalConfigInfo() {
      getGlobalServerConfig().then(response => {
        if (response.isSuccess) {
          let data = response
          // let data = response.data;
          this.commonUrlForm = {
            commonUrl: data.commonUrl
          }
          this.serverForm = {
            isMinio: data.isMinio,
            isAllowConvert: data.isAllowConvert,
            conversionNum: data.conversionNum,
            resourcesAddress: data.resourcesAddress
          }
          this.servers = data.servers
          this.zoneManageServers = data.zoneManageServers
        }
      })
    },
    next() {
      this.$refs.serverForm.validate((bool, object) => {
        if (bool) {
          this.activeTab = 'zoneManageServers'
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    },
    openZoneManageServersDialog() {
      this.zoneManageServersConfigVisible = true
    },
    addZoneManageServersConfig() {
      this.$refs.zoneManageServersForm.validate((bool, object) => {
        if (bool) {
          this.zoneManageServers.push(this.zoneManageServersForm)
          this.closeZoneManageServersDialog()
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    },
    closeZoneManageServersDialog() {
      this.zoneManageServersForm = {
        zoneId: '',
        rootName: '',
        rootDir: '',
        remoteHostUrl: ''
      }
      this.zoneManageServersConfigVisible = false
    },
    openServersConfigDialog() {
      this.serversConfigVisible = true
    },
    addServersConfig() {
      this.$refs.serversForm.validate((bool, object) => {
        if (bool) {
          this.servers.push(this.serversForm)
          this.closeZoneManageServersDialog()
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    },
    closeServersConfigDialog() {
      this.serversForm = {
        ip: '',
        exePath: '',
        cachePath: ''
      }
      this.serversConfigVisible = false
    },
    submitGlobalConfig() {
      let params = {
        commonUrl: this.commonUrlForm.commonUrl,

        isMinio: this.serverForm.isMinio,
        isAllowConvert: this.serverForm.isAllowConvert,
        conversionNum: this.serverForm.conversionNum,
        resourcesAddress: this.serverForm.resourcesAddress,
        servers: this.servers,
        zoneManageServers: this.zoneManageServers
      }
      setGlobalServerConfig(params).then(response => {
        if (response.isSuccess) {
          this.$message.success('配置成功')
          // this.$router.push("./projectList");
        }
      })
    },
    deleteRow(index, data) {
      this.$confirm('确定要删除此配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          data.splice(index, 1)
        })
        .catch(() => {
          // this.$message.info('取消删除!')
        })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.transform-config {
  height: 100%;
}
.service-config-container {
  height: 100%;
  padding: 15px;
  background: var(--page-bgColor);
  box-shadow: var(--base-bg-dark-color30);

  .service-header {
    padding: 5px 0px;
    text-align: left;
    color: var(--page-title-color);
  }

  .common-tabs-box {
    height: calc(100% - 50px);

    .tabs-box {
      height: 100%;
      :deep(.el-tabs__header) {
        .el-tabs__item {
          color: var(--tab-text-color);
          font-size: 14px;
          font-weight: 400;
        }

        .is-active {
          color: var(--base-primary-bgColor);
        }

        .el-tabs__active-bar {
          background-color: var(--base-primary-bgColor);
        }
      }
      :deep(.el-tabs__content) {
        height: 100%;
        padding-left: 16px;

        .transform-config {
          height: 100%;

          .common-table-box {
            height: calc(100% - 48px);

            .empty-page {
              height: 100%;
            }
          }
        }
      }
      .server-form-box {
        width: 60%;
        .justify-flex {
          :deep(.el-button) {
            height: 36px;
            margin-top: 3px;
          }
        }

        .last-item {
          text-align: end;
        }

        .serve-config-form {
          margin-bottom: 28px;
          :deep(.el-form-item__label) {
            line-height: 32px;
          }

          :deep(.el-form-item__content) {
            line-height: 32px;
            height: 32px;

            .el-input__inner {
              height: 32px;
              line-height: 32px;
            }

            .el-form-item__error{
              margin-top: 6px;
            }
          }
        }
      }

      .top-btn {
        text-align: left;
        margin-bottom: 15px;
        margin-left: 16px;
      }

      .bottom-btn {
        text-align: end;
        margin-top: 15px;
      }
    }
  }

  .dialog-form {
    :deep(.el-form-item__content) {
      .el-input__inner {
        height: 32px;
      }
    }
  }

  // .el-tabs {
  //   .el-tabs__header {
  //     .el-tabs__nav-wrap::after {
  //       display: block;
  //     }
  //   }

  //   .el-tabs__content {
  //     overflow: hidden;
  //   }
  // }
}
</style>
